import { configureStore } from '@reduxjs/toolkit';
import holidayCounterReducer from './reducers/holidayCounterReducer';
import holidayReducer from './reducers/holidayReducer';
import overtimeReducer from './reducers/overtimeReducer';
import healthSafetyReducer from './reducers/healthSafetyReducer';
const store = configureStore({
  reducer: {
    holidayCounter: holidayCounterReducer,
    holiday: holidayReducer,
    overtime: overtimeReducer,
    healthSafety: healthSafetyReducer,
  },
});

export default store;
